import { createFileRoute, redirect } from "@tanstack/react-router";
import { AdminContactPanel } from "@/features/contact/admin-panel";
import { authClient } from "@/lib/auth-client";

export const Route = createFileRoute("/_authenticated/admin/contact")({
  // The parent _authenticated layout already requires a session; this adds the
  // admin gate. Server-side oRPC handlers re-check isAdmin, so this is UX-only.
  beforeLoad: async () => {
    const session = await authClient.getSession();
    const isAdmin = (session?.data?.user as { isAdmin?: boolean } | undefined)
      ?.isAdmin;
    if (!isAdmin) {
      throw redirect({ to: "/" });
    }
  },
  component: AdminContactPanel,
});
